/* eslint-disable react/self-closing-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { selectAuthAccountData } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { generatePopUpLink } from 'components/Common/GlobalPopUps/utils';

import Header from './Header/index';
import Sidebar from './Sidebar/index';
import Content from './Content/index';

class LayoutApp extends Component {
  componentDidMount() {
    // Открываем модалку по url hash если нет timeZone у пользователя.
    // По таймауту тк если есть редиректы в роутах хэш не подставится
    if (this.props.authAccountData.showSettingsModal) {
      setTimeout(() => {
        this.props.history.push(
          generatePopUpLink(this.props.location, 'choiceTimezone')
        );
      }, 2 * 1000);
    }
  }

  render() {
    return (
      <div className="page page-panel">
        <Header />
        <div className="container page-container_sticky">
          <div className="row">
            <Sidebar />
            <Content />
          </div>
        </div>
        <div className="j-m-toggle"></div>
      </div>
    );
  }
}

LayoutApp.propTypes = {
  authAccountData: PropTypes.shape({
    timeZone: PropTypes.string,
    showSettingsModal: PropTypes.number
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};

const mapStateToProps = state => ({
  authAccountData: selectAuthAccountData(state)
});

export default withRouter(connect(mapStateToProps)(LayoutApp));



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/LayoutApp.js